import React from 'react';
import ProjektSelector from './ProjektSelector';
import './TopBar.css';

const TopBar = ({ onSidebarSettingsClick, sidebarSettingsActive, onProjekteClick, projekteActive }) => {
  return (
    <div className="topbar-container">
      <div className="topbar-content">
        <ProjektSelector />
        <div className="topbar-buttons">
          <button
            className={`topbar-btn${sidebarSettingsActive ? ' active' : ''}`}
            onClick={onSidebarSettingsClick}
          >
            Sidebar-Menü
          </button>
          <button
            className={`topbar-btn${projekteActive ? ' active' : ''}`}
            onClick={onProjekteClick}
          >
            Projekte
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopBar; 